export enum ProductNamesInRussian {
	RKO = 'РКО',
	RBO = 'РБО',
}

export const YA_METRIKA_ID = 47481808
